import { render, staticRenderFns } from "./Preregistered.vue?vue&type=template&id=735da14c&scoped=true&"
import script from "./Preregistered.vue?vue&type=script&lang=js&"
export * from "./Preregistered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735da14c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('735da14c', component.options)
    } else {
      api.reload('735da14c', component.options)
    }
    module.hot.accept("./Preregistered.vue?vue&type=template&id=735da14c&scoped=true&", function () {
      api.rerender('735da14c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Preregistered.vue"
export default component.exports